import MetaView from './views/meta';
import content from './content';

const Meta = ({service} : { service: string }) => { 
    const contentData: {title: string, canonical: string, description: string, keywords: string} = content(service);
    
    return <MetaView 
        title={contentData.title} 
        canonical={contentData.canonical} 
        description={contentData.description} 
        keywords={contentData.keywords} 
    />
}

export default Meta;